// 渲染footer
function cnsRenderFooter(footerBlocks) {
	console.assert(footerBlocks && typeof footerBlocks === "string");
	const footerEl = document.getElementById("cns-footer");
	console.assert(footerEl);
	footerEl.innerHTML = footerBlocks;
}

// 渲染header菜单入口 for bootstrap
function cnsRenderNavMenu(ghostNav, rootUl) {
	const menuArr = transNav(ghostNav);
	// console.log('render main nav', menuArr);
	cnsRenderNavList(menuArr, rootUl);
	// console.log(rootUl);
}

// 渲染整个导航菜单的函数 for bootstrap
function cnsRenderNavList(menuArr, parentUl) {
	menuArr?.forEach(function(item) {
		const liTemp = cnsRenderNavItem(item);
		// parentUl.appendChild(li);
		parentUl.innerHTML += liTemp;
		const li = parentUl.lastElementChild;
		// console.log(li);

		// 如果存在子菜单，则渲染子菜单
		if (item?.children?.length > 0) {
			// const dropdownBtn = document.createElement('button');
			// dropdownBtn.className = 'submenu-dropdown-btn';
			// dropdownBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7,10L12,15L17,10H7Z" /></svg>';
			// li.appendChild(dropdownBtn);

			const subUl = document.createElement('ul');
			subUl.classList.add('dropdown-menu');
			li.appendChild(subUl);
			cnsRenderNavList(item.children, subUl);
		}
	});
}

// 渲染导航菜单项的函数 for bootstrap
function cnsRenderNavItem(item) {
	let temp;

	if (item.children) { // 包含子菜单，使用bootstrap dropdown
		temp = `
			<li class="nav-item dropdown ${item.classList}">
				<a class="nav-link dropdown-toggle" href="${item.url}" role="button" data-bs-toggle="dropdown" aria-expanded="false">
					${item.label}
				</a>		
			</li>`;
	}	else {
		const liClass = item.isSub ? "" : "nav-item";
		const aClass = item.isSub ? "dropdown-item" : "nav-link";
		temp = `
			<li class="${liClass} ${item.classList}">
				<a class="${aClass} py-2" href="${item.url}">${item.label}</a>
			</li>`;
	}
	return temp;
}

// 渲染二级导航菜单 for ghost casper theme
/*
// 渲染header菜单入口
function cnsRenderGhostNavMenu(ghostNav, rootUl) {
	const menuArr = transNav(ghostNav);
	// console.log('render main nav', menuArr);
	cnsRenderNavList(menuArr, rootUl);
	// console.log(rootUl);
}

// 渲染整个导航菜单的函数
function cnsRenderGhostNavList(menuArr, parentUl) {
	menuArr?.forEach(function(item) {
		const li = cnsRenderGhostNavItem(item, parentUl);
		parentUl.appendChild(li);
		// console.log(parentUl);

		// 如果存在子菜单，则渲染子菜单
		if (item?.children?.length > 0) {
			// const dropdownBtn = document.createElement('button');
			// dropdownBtn.className = 'submenu-dropdown-btn';
			// dropdownBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7,10L12,15L17,10H7Z" /></svg>';
			// li.appendChild(dropdownBtn);

			const subUl = document.createElement('ul');
			subUl.classList.add('sub-menu');
			li.appendChild(subUl);
			cnsRenderGhostNavList(item.children, subUl);
		}
	});
}

// 渲染导航菜单项的函数
function cnsRenderGhostNavItem(item) {
	const li = document.createElement('li');
	const a = document.createElement('a');

	a.href = item.url;
	a.innerText = item.label;
	if (item.classList)
		li.className = item.classList;
	li.appendChild(a);
	return li;
}

// 创建一个<li><a><img>元素, 其中<img>可选
function cnsCreateNavLi(item) {
	const li = document.createElement('li');
	const a = document.createElement('a');

	a.href = item.url;
	if (item.image) {
		const img = document.createElement('img');
		img.src = item.image;
		a.appendChild(img);

		const span = document.createElement('span');
		span.innerText = item.label;
		a.appendChild(span);
	}	else {
		a.innerText = item.label;
	}

	// TODO: 判断是否为外部链接，若是，则添加相关属性
	if (!item.url.startsWith('/')) {
		// 设置 target 属性为 "_blank"，以在新标签页中打开链接
		a.setAttribute('target', '_blank');
		// 设置 rel 属性为 "noopener"，以增加安全性
		a.setAttribute('rel', 'noopener');
	}

	if (item.classList) {
		li.className = item.classList;
	}
	li.appendChild(a);
	return li;
}
*/

// 转换一维navigation为树状结构，以支持二级菜单
function transNav(navigation) {
	const transformed = [];
	const map = {};

	function createSubItem(parent, childLabel) {
		return { ...parent, label: childLabel, isSub: true };
	}

	navigation.forEach((item) => {
		const parts = item.label.split('/');
		const parentLabel = parts[0];
		const childLabel = parts[1];

		// TODO: 目前只允许主菜单项定义在前，待处理
		if (!childLabel) {
			if (!map[parentLabel]) {
				map[parentLabel] = item;
			}
			transformed.push(item);
			return;
		}

		if (!map[parentLabel]) {
			const newItem = {
				...item,
				label: parentLabel,
				children: [createSubItem(item, childLabel)],
			};
			map[parentLabel] = newItem;
			transformed.push(newItem);
		} else {
			map[parentLabel].children ||= [];
			map[parentLabel].children.push(createSubItem(item, childLabel));
		}
	})
	return transformed;
}		

/**
 * userProfileVer操作.
 */
// 删除localStorage中为用户保存的各种资源的版本号.
function removeUserVers() {
	localStorage.removeItem('userProfileVer');
	localStorage.removeItem('userSettingVer');
}
// 从localStorage读取userProfile的版本号.
function getUserProfileVer() {
	return localStorage.getItem('userProfileVer') || undefined;
}

// 处理用户登录登出等
async function cnsProcLogin() {
	const NULL_IMG = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"; // 1x1像素的透明图像的 Data URL
	let userProfile;
	
	const $loginBtn = document.getElementById('cns-login-btn');
	const $userBox = document.getElementById('cns-user-box');
	const $userName = document.getElementById('cns-user-name');
	const $userAvatar = document.getElementById('cns-user-avatar');
	const $userLogout = document.getElementById('cns-user-logout');

	if (!$loginBtn || !$userBox || !$userName || !$userAvatar || !$userLogout) {
		console.error(`login eles not exist`);
		// return;
	}
	// if (!axios) {
	// 	console.error(`axios not exist`);
	// 	return;
	// }

	// userLogout处理器
	// if ($userLogout) {
	// 	$userLogout.href = "/api/auth/logout?retTo=" + encodeURIComponent(window.location.href);
	// }
	$userLogout.addEventListener('click', (evt) => {
		// console.log(`onLogout`);
		evt.preventDefault();
		removeUserVers();
		window.location.href = "/api/auth/logout?retTo=" + encodeURIComponent(window.location.href);;
	});

	// 已替换 axios 为原生 fetch
	// 通过获取用户profile来判断用户是否处于登录状态
	// try {
	// 	const res = await axios.get(`/api/user/profile`, { 
	// 		params: { v: getUserProfileVer() }
	// 	});
	// 	userProfile = res.data;
	// 	// console.log(`userProfile:`, userProfile);
	// }	catch (err) {
	// 	err.response?.status != 401 && console.error(`getUserProfile FAIL, err=`, err);
	// }
	try {
		const v = getUserProfileVer();
		const queryParams = new URLSearchParams({ v }).toString();
		const response = await fetch(`/api/user/profile?${queryParams}`);
		if (!response.ok) {
			// 在这里可以根据状态码进行相应的处理
			// 比如:
			// if (response.status !== 401) {
			//   console.error(`getUserProfile FAIL, status=${response.status}`);
			// }
			throw new Error(`fetch with invalid status ${response.status}`);
		}
		userProfile = await response.json();
		// console.log(`userProfile:`, userProfile);
	} catch (err) {
		console.error(`getUserProfile FAIL, err=`, err);
	}

	updateUser();

	// 根据登录状态进行对应渲染
	function updateUser() {
		if (userProfile) {
			$userName.innerText = userProfile.name || "匿名";
			if (userProfile.avatar) {
				$userAvatar.src = userProfile.avatar;
				$userAvatar.hidden = false;
			}	else {
				$userAvatar.hidden = true;
			} 
			$loginBtn.parentNode.hidden = true;
			$userBox.hidden = false;
		}	else {
			$userName.innerText = "";
			$userAvatar.src = NULL_IMG;
			$userAvatar.hidden = true;
			$userBox.hidden = true;
			$loginBtn.parentNode.hidden = false;
		}
	}
}

// 导航的app. 需要跳出网站，因此不能直接用<a>
function cnsListenNavToApp(url, selectors) {
	// 遍历每个选择器
	selectors.forEach(function(selector) {
		// 获取该选择器下的所有元素
		const elements = document.querySelectorAll(selector);

		// 为每个元素添加点击事件监听器
		elements.forEach(function(element) {
			element.addEventListener('click', function(event) {
				event.preventDefault();
				window.location.href=url;
			});
		});
	});
}

// 导航的apps.
function cnsListenNavToApps() {
	cnsListenNavToApp('/chat', [`.nav-item.nav-qi-dian-hui-yu a`, `a.tag-apps.product-chat`]);
	cnsListenNavToApp('/user', [`a.tag-apps.product-user`]);
	// cnsListenNavToApp('https://demo.qidianchat.com/', [`.nav-item.nav-demo a`]);
}
